import httpService from "@/utils/request";

const dictionaryService = {
  // 创建
  createDictionary: (params: any) => {
    const url = "/business/dictionary/createDictionary";
    return httpService.post(url, params);
  },
  // 删除
  deleteDictionary(id: any) {
      const url = "/business/dictionary/deleteDictionary/"+id;
      return httpService.delete(url);
  },
  // 查询详情
  getDictionary(id: any) {
    const url = "/business/dictionary/getDictionary/"+id;
    return httpService.get(url);
  },
  // 分页获取
  getDictionaryPageListByParams: (params: any) => {
    const url = "/business/dictionary/getDictionaryPageListByParams";
    return httpService.post(url, params);
  },
  // 更新
  updateDictionary: (params: any) => {
    const url = "/business/dictionary/updateDictionary";
    return httpService.put(url, params);
  },
  // 更新
  refreshDictionaryCache: () => {
    const url = "/business/dictionary/refreshDictionaryCache";
    return httpService.put(url);
  },

  // 创建
  createDictionaryItem: (params: any) => {
    const url = "/business/dictionary-item/createDictionaryItem";
    return httpService.post(url, params);
  },
  // 删除
  deleteDictionaryItem(id: any) {
      const url = "/business/dictionary-item/deleteDictionaryItem/"+id;
      return httpService.delete(url);
  },
  // 查询详情
  getDictionaryItem(id: any) {
    const url = "/business/dictionary-item/getDictionaryItem/"+id;
    return httpService.get(url);
  },
  // 分页获取
  getDictionaryItemPageListByParams: (params: any) => {
    const url = "/business/dictionary-item/getDictionaryItemPageListByParams";
    return httpService.post(url, params);
  },
  // 更新
  updateDictionaryItem: (params: any) => {
    const url = "/business/dictionary-item/updateDictionaryItem";
    return httpService.put(url, params);
  },
  // 获取全部
  getDictionaryItemListByDictCode: (code: any) => {
    const url = `/business/dictionary-item/getDictionaryItemListByDictCode/${code}`;
    return httpService.get(url);
  },


  getDictionaryByCode: (code: any) => {
    const url = `/business/dictionary/getDictionaryByCode/${code}`;
    return httpService.get(url);
  },
  
}

export default dictionaryService;